<template>
   <!-- The Modal -->
    <div class="modal" id="alertModal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header p-2">
                <h4 class="modal-title">{{title ? title :'Alert Message'}}</h4>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"  @click="closeAlert()"></button> -->
            </div>

            <!-- Modal body -->
            <div class="modal-body p-4">
                <p class="msg text-center">{{notifyMsg}}</p>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer p-2">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="closeAlert()">Ok</button>
            </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"alert-modal",
    data(){
        return {
            notifyMsg:null,
            title:null,
            newUrl:'',
        }
    },
    methods:{
        showAlert(title, msg, url = ''){
            const self= this;
            self.notifyMsg = msg;
            self.title = title;
            self.newUrl = url;
            $("#alertModal").show();
        },
        closeAlert(){
             const self= this;
            self.notifyMsg = null;
            self.title = null;
            $("#alertModal").hide()
            if(self.newUrl != '')
            {
                self.$router.push(self.newUrl);
            }
        }

    }
}
</script>

<style>
.modal{background:hsl(0deg 0% 7% / 50%)}
#alertModal .modal-dialog{max-width: 320px;}
.modal-title{font-size: 1rem;}
.modal-body .msg{font-size: 1rem;text-transform: capitalize;}

</style>